export const isFree = ({
  currentPrice,
  originalPrice,
}: {
  currentPrice: number;
  originalPrice: number;
}): boolean => {
  return currentPrice === 0 && originalPrice === 0;
};
